var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MyNav'),_c('div',{staticClass:"auth-wrapper"},[_c('div',{staticClass:"auth-inner"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }